module.exports = __webpack_public_path__ + "static/media/icon_warning.d6cb7e2f.svg";